// extracted by mini-css-extract-plugin
export var container = "_8x-1";
export var cornerButtonContainer = "_8x-5";
export var disabled = "_8x-2";
export var fileContainer = "_8x-4";
export var hiddenInput = "_8x-3";
export var widthContainer = "_8x-0";